export const Black = "Black";
export const Blue = "Blue";
export const EightyPercentLighterColor = "80% lighter {0}";
export const FortyPercentLighterColor = "40% lighter {0}";
export const Green = "Green";
export const Indigo = "Indigo";
export const Orange = "Orange";
export const Pink = "Pink";
export const Purple = "Purple";
export const Red = "Red";
export const SixtyPercentLighterColor = "60% lighter {0}";
export const Teal = "Teal";
export const TenPercentLighterColor = "10% lighter {0}";
export const Turquoise = "Turquoise";
export const TwentyPercentLighterColor = "20% lighter {0}";
export const White = "White";
export const Yellow = "Yellow";
